define('popupProductView',[
  'module',
  'marionette',
  'app',
  'backbone',
  'underscore',
  'jquery',
  'settings',
  'dialogFormView',
  'dynamicTextView',
  'template!popupCreateProductTpl'
], function (
  module,
  Marionette,
  App,
  Backbone,
  _,
  $,
  Settings,
  DialogFormView,
  DynamicTextView,
  popupCreateProductTpl
) {
  'use strict';

  module.exports = DialogFormView.extend({
    template: popupCreateProductTpl,

    ui: {
      input: '.js-info-input',
      cancel: '.js-cancel',
      confirm: '.js-confirm',
      notRelevantFor3d: '.notRelevantFor3d'
    },

    regions: {
      nameRegion: '.name-region',
      descriptionRegion: '.description-region'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input': 'onFocus',
      'change @ui.input': 'onInputChange',
      'click @ui.confirm': 'onConfirm',
      'click @ui.cancel': 'onCancel',
      'change @ui.notRelevantFor3d': 'onChangeNotRelevantFor3d'
    },

    modelEvents: {
      sync: 'onSave'
    },

    initialize: function () {
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onChangeNotRelevantFor3d: function () {
      this.model.set('notRelevantFor3d', this.ui.notRelevantFor3d.is(':checked'));
      this.triggerMethod('enable:cancel:confirm');
    },

    onRender: function () {
      $.material.init();
      this.nameDtView = new DynamicTextView({model: this.model.get('name')});
      this.getRegion('nameRegion').show(this.nameDtView);
      this.descriptionDtView = new DynamicTextView({model: this.model.get('description')});
      this.getRegion('descriptionRegion').show(this.descriptionDtView);
    },

    onConfirm: function () {
      this.model.save();
    },

    onEscape: function () {
      if (!this.newItem) {
        this.model = null;
      }
    },

    onCancel: function () {
      if (!this.newItem) {
        this.model = null;
      }
      this.hide();
    },

    onSave: function () {
      this.triggerMethod('saved');
      this.model = null;
      this.hide();
    }
  });
});
